import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store/Module/VersionHistory
 * @project ChalkySticks App
 */
const mutations = {
	/**
	 * Add a version to the seen versions array
	 *
	 * @param State state
	 * @param string version
	 * @return void
	 */
	addSeenVersion(state: typeof State, version: string): void {
		if (!state.seenVersions.includes(version)) {
			state.seenVersions.push(version);
		}
	},

	/**
	 * Record when a version was first seen
	 *
	 * @param State state
	 * @param object payload
	 * @return void
	 */
	recordVersionFirstSeen(state: typeof State, payload: { timestamp: number; version: string }): void {
		if (!state.versionFirstSeenDates[payload.version]) {
			state.versionFirstSeenDates[payload.version] = payload.timestamp;
		}
	},

	/**
	 * Set the last seen version (previous version before upgrade)
	 *
	 * @param State state
	 * @param string | null version
	 * @return void
	 */
	setLastSeenVersion(state: typeof State, version: string | null): void {
		state.lastSeenVersion = version;
	},
};

export default mutations;
